import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import '../api/devBypass';

const SKIP_AUTH = process.env.REACT_APP_SKIP_AUTH === 'true';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, isReady } = useAuth();

  // Dev mode — bypass auth entirely
  if (SKIP_AUTH) {
    return <>{children}</>;
  }

  // Auth still initializing — show spinner
  if (isLoading || !isReady) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Auth settled and not authenticated — redirect immediately
  if (!isAuthenticated) {
    console.log('[auth] ProtectedRoute: not authenticated, redirecting to /login');
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
